import { useEffect, useState } from "react"
import { useSnapshot } from "valtio"
import Api from "../state/Api"
import { configStore, loginStore } from "../state/CommonState"
import { loader } from "../util/loader"
import { myactionsstore } from "./store-myactions"

const SOURCE_LABELS = { OCEAN: 'Ocean Tracking', US_LCL: 'US Tracking' }
const POLL_MS = 2 * 60 * 1000

const when = (iso) => { try { return iso ? new Date(iso).toLocaleString() : '' } catch (e) { return '' } }

/**
 * Top of the Visibility page (staff only): bookings whose tracking webhooks are held because the
 * reported POR/POL/POD/FPOD differs from the booking. Nothing is saved for them until ops decide here
 * (or in the booking's own popup). Refreshed every 2 minutes and whenever the list reloads.
 */
export function RouteReviewBanner() {
    useSnapshot(myactionsstore)
    const [list, setList] = useState([])
    const [open, setOpen] = useState(false)

    const load = () => Api.listTrackingRouteReviews((data) => setList(Array.isArray(data?.results) ? data.results : []))

    useEffect(() => {
        if (loginStore.isClient()) return undefined
        load()
        const t = setInterval(load, POLL_MS)
        return () => clearInterval(t)
    }, [myactionsstore.recheck])

    if (loginStore.isClient() || list.length === 0) return null

    const decide = (r, action) => {
        loader.show()
        Api.decideTrackingRouteReview({ bookingNum: r.bookingNum, source: r.source, action }, (res) => {
            loader.hide()
            if (res?.message) configStore.setModalMessage(`${r.bookingNum}: ${res.message}`)
            setList((l) => l.filter((x) => !(x.bookingNum === r.bookingNum && x.source === r.source)))
            myactionsstore.recheck = myactionsstore.recheck === 0 ? 1 : 0   // reload the visibility list
        }, () => loader.hide())
    }

    const count = new Set(list.map((r) => r.bookingNum)).size
    return (
        <div className="notification is-warning is-light py-2 px-3 mb-2" style={{ fontSize: '0.85rem' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '0.5rem' }}>
                <span>
                    <span className="icon"><i className="fas fa-exclamation-triangle"></i></span>
                    <strong>Route change from tracking:</strong>{' '}
                    {count} booking{count > 1 ? 's are' : ' is'} waiting for Accept / Decline. No tracking data is saved for {count > 1 ? 'them' : 'it'} until you decide.
                </span>
                <button className="button is-small is-warning" onClick={() => setOpen(!open)}>
                    {open ? 'Hide' : 'Review'}
                </button>
            </div>
            {open && (
                <table className="table is-narrow is-fullwidth mt-2" style={{ fontSize: '0.8rem', background: 'transparent' }}>
                    <thead>
                        <tr>
                            <th>Booking</th>
                            <th>Source</th>
                            <th>Change (booking → tracking)</th>
                            <th>Since</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {list.map((r) => (
                            <tr key={`${r.bookingNum}-${r.source}`}>
                                <td><strong>{r.bookingNum}</strong>{r.shipmentType ? ` (${r.shipmentType})` : ''}</td>
                                <td>{SOURCE_LABELS[r.source] || r.source}</td>
                                <td>{(r.changes || []).map((c) => `${c.label}: ${c.current} → ${c.incoming}`).join(', ')}</td>
                                <td>{when(r.detectedAt)}</td>
                                <td style={{ whiteSpace: 'nowrap' }}>
                                    <button className="button is-small is-danger is-light mr-1" onClick={() => decide(r, 'decline')}>Decline</button>
                                    <button className="button is-small is-success" onClick={() => decide(r, 'accept')}>Accept</button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </div>
    )
}
